export default function hasNumericCharacter(value: string) {
  return /[0-9]/.test(value);
}
